import React from "react";

import StbBreadcrumb from "@storeblocks/breadcrumbs";
import { useSetBreadcrumbs } from "./breadcrumb.hooks";

export const Breadcrumb = (): React.ReactElement | null => {
  const crumbs = useSetBreadcrumbs();

  if (crumbs.length === 0) {
    return null;
  }

  return (
    <StbBreadcrumb>
      {crumbs.map((crumb) => (
        <a key={crumb.href} href={crumb.href} target="_blank" rel="noreferrer">
          {crumb.title}
        </a>
      ))}
    </StbBreadcrumb>
  );
};
